const URLSeachParamsCreator = function (obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      var value = obj[p];
      // Skip nullish values so we never emit e.g. `departure=undefined`, which
      // downstream providers reject (Amadeus: "originLocationCode must be a
      // 3-letter code"). Naive `p + '=' + value` would stringify JS undefined
      // to the literal "undefined".
      if (value == null || value === 'undefined' || value === 'null') {
        continue;
      }
      str.push(p + '=' + value);
    }
  return str.join('&');
};

export default URLSeachParamsCreator;
